/* eslint-disable no-console, prefer-destructuring, func-names, no-underscore-dangle */

import store from '@/store';
import utils from '@/utils/utils';
import Vue from 'vue';
import EventBus from '@/eventBus';

class Bot {
  constructor(name, difficulty = Bot.Difficulty.EASY) {
    // avoid object being observed by vue
    const Observer = new Vue().$data.__ob__.constructor;
    this.__ob__ = new Observer({});

    this.id = Date.now().toString();
    this.name = name;
    this.type = 'bot';
    this.score = 0;

    this.difficulty = difficulty;

    this.rememberedCards = {};

    this.cardsToTurnNext = [];
    this.cardTurnedLast = null;

    EventBus.$on('card.turned', ({
      card,
    }) => {
      this.seeTurnedCard(card);
      this.maybeForgetSomething();
    });
  }

  static Difficulty = {
    EASY: {
      forgetfulness: 5,
      minAmountOfCards: 3,
    },
    MEDIUM: {
      forgetfulness: 3,
      minAmountOfCards: 5,
    },
    HARD: {
      forgetfulness: 1,
      minAmountOfCards: 8,
    },
  };

  maybeForgetSomething = function () {
    const randomInt = utils.genRandomInt(0, 10);

    const rememberedCardsArray = Object.values(this.rememberedCards);

    if (
      this.rememberedCards
      && rememberedCardsArray.length > this.difficulty.minAmountOfCards
      && randomInt <= this.difficulty.forgetfulness
    ) {
      const idToForget = rememberedCardsArray.find(cardArray => cardArray.length === store.getters
        .gameSettings.cardsToTurn)
        || utils.getRandomElementFromArray(rememberedCardsArray);

      const removedCard = idToForget.pop();

      if (idToForget.length === 0) {
        delete this.rememberedCards[removedCard.id];
      }

      console.log(`[${this.name}] forgot card`, removedCard);
    }
  };

  turnCard = async function () {
    await utils.wait(1000);

    let cardToTurn = null;

    let hasCard = false;

    if (!utils.isEmpty(this.cardsToTurnNext)) {
      cardToTurn = this.cardsToTurnNext.pop();
      if (!cardToTurn.isTurned) {
        hasCard = true;
      }
    }

    if (!hasCard) {
      const cardPair = Object.values(this.rememberedCards).find(
        cardsArray => cardsArray.length === store.getters.gameSettings.cardsToTurn,
      );

      if (cardPair) {
        cardToTurn = cardPair.shift();
        this.cardsToTurnNexts = cardPair;
        delete this.rememberedCards[cardToTurn.id];
      } else {
        const unturnedCards = store.getters.unturnedCardsArray.filter((c) => {
          const isNotTempTurned = !this.cardTurnedLast || this.cardTurnedLast.index !== c
            .index;
          return isNotTempTurned;
        });

        cardToTurn = unturnedCards[Math.floor(Math.random() * unturnedCards.length)];
      }
    }

    if (!cardToTurn) return false;

    this.cardTurnedLast = cardToTurn;

    console.log(`[${this.name}] turning card`, cardToTurn);

    cardToTurn.playerId = this.id;

    await store.dispatch('turnCard', {
      card: cardToTurn,
    });
    return true;
  };

  seeTurnedCard = function (card) {
    if (!this.rememberedCards[card.id]) {
      this.rememberedCards[card.id] = [];
    }
    if (!this.rememberedCards[card.id].find(c => c.index === card.index)) {
      console.log(`[${this.name}] remembered card`, card);
      this.rememberedCards[card.id].push(card);
    } else {
      console.log(`[${this.name}] already remembered that card`);
    }
  };

  deleteRememberedCardId = function (card) {
    delete this.rememberedCards[card.id];
    this.cardsToTurnNext = null;
  };
}

export default Bot;
